/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react'
import i18n from 'live/services/i18n'
import Highcharts from 'highcharts'
import Label from 'plugin-pressuretests/shared/components/lotfit/Label'
import Table from 'plugin-pressuretests/shared/components/lotfit/Table'
import { Chart } from 'plugin-pressuretests/shared/components/lotfit/Modal.style'
import { drawChart, getOptionTable } from 'plugin-pressuretests/shared/components/lotfit/LotFitAnnotation'
import { TestOption } from '../types'
import styled, { CSSProperties } from 'styled-components'
const LotFitCorrelatedTest = ({
    _test,
    updateGetCharts,
    style
}: {
    _test: TestOption
    updateGetCharts?: (callback: () => Record<string, any>) => void
    style?: CSSProperties
}) => {
    const [chart, setChart] = useState(null)

    const extra = _test.data?.extra
    const chartRef = useRef(null)
    const tableRef = useRef(null)
    const titleRef = useRef(null)
    const testInfoRef = useRef(null)
    const testType = extra.params.testType
    const optionsTable = getOptionTable(extra)
    const userAbsorptionPressureDefined = extra?.params?.userAbsorptionPressure

    useEffect(() => {
        updateGetCharts?.(() => {
            return {
                chart: chartRef.current,
                table: tableRef.current,
                title: titleRef.current,
                testInfo: testInfoRef.current

            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (chartRef?.current) {
            const chartOpts = drawChart(extra)
            if (chartOpts) {
                setChart(Highcharts.chart(chartRef?.current, chartOpts))
            }
        }
    }, [chartRef?.current, extra])

    return (
        <Content style={style}>
            <div className="pt-additional-information">
                <div ref={testInfoRef}>

                    <Label title={i18n('Asset')} subtitle={extra?.params?.assetConfig?.asset} />
                    <Label title={i18n('Pressure channel')} subtitle={extra?.params?.pressureChannel} />
                    <Label title={i18n('Volume channel')} subtitle={extra?.params?.volChannel} />
                    <Label title={i18n('Flow channel')} subtitle={extra?.params?.flowChannel} />
                </div>
                <WrapperChart >
                    <Chart ref={chartRef} />
                </WrapperChart>
                <ContentTable ref={tableRef}>

                    <Table options={optionsTable} />
                    {userAbsorptionPressureDefined && (
                        <SmallNote>* {i18n('Absorption pressure defined manually')}</SmallNote>
                    )}
                    <EquivalentMudWeight>
                        <div>
                            <div>{i18n('Equivalent mud weight')}</div>
                        </div>
                        <div>
                            {`${extra?.result?.equivalentMudWeight?.toFixed(2)} ${extra?.result?.lotFitUnits?.outputEquivalentResult
                                }` || '-'}
                        </div>
                    </EquivalentMudWeight>
                </ContentTable>
                <Comment>
                    <div>
                        <TitleComment>{i18n('Comment')}</TitleComment>
                    </div>
                    <textarea disabled={true}>{_test.data?.message}</textarea>
                </Comment>
            </div>
        </Content>
    )
}

export default LotFitCorrelatedTest

const Content = styled.div`
    .pt-additional-information {
        border: 1px solid #ccc;
        border-left: none;
        border-right: none;
        padding-bottom: 20px;
        margin-top: 20px;
    }
`

const ContentTable = styled.div`
    max-width: 600px;
`

const EquivalentMudWeight = styled.div`
    margin-top: 16px;
    display: grid;
    grid-template-columns: 1.28fr 1fr;
    height: 61px;
    border: 1px solid #bac0cb;

    div:first-child {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #dddee1;
        font-weight: bold;
        font-size: 13px;
        padding-left: 8px;
        i {
            color: #37a3ef;
            padding: 0px 5px;
        }
        div {
            padding-left: 0px;
        }
    }
    div:nth-child(2) {
        background-color: #eeeeee;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        font-size: 13px;
    }
`
const WrapperChart = styled.div`
    margin-top: 32px;
    margin-bottom: 16px;
    border: 1px solid #bac0cb;
`

const Comment = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    border: 1px solid #bac0cb;
    div:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 32px;
        background-color: #eee;
        padding: 0 8px;
        border-bottom: 1px solid #bac0cb;
        i {
            font-size: 13px;
            color: #37a3ef;
        }
    }
    textarea {
        border: none;
        color: #828ca1;
    }
    .fa-edit {
        cursor: pointer;
    }
`

const TitleComment = styled.div`
    font-size: 13px;
    font-weight: bold;
`

const ButtonComment = styled.div`
    display: flex;
    margin-top: 10px;
    > button {
    }
`
const SmallNote = styled.div`
    color: gray;
    font-size: 12px;
    margin-top: 5px;
`
